export enum ProjectOAuth2OktaPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
}
